import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ISectionsDatasource } from '../../views/sections/datasources/sections_datasource';
import { RegistrationAlertsServant } from '../../views/course_scheduler/servants/registration_alerts_servant';

angular
  .module('capability-ng-scheduler')
  .service(
    'updateSwapSectionStatusCommand',
    function updateSwapSectionStatusCommandDefinition(
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngCourseSectionSwapModel: any,
      log: any,
      ngSectionsDatasource: ISectionsDatasource,
      ngRegistrationAlertsServant: RegistrationAlertsServant
    ) {
      'use strict';

      return defineCommandORM(
        'updateSwapSectionStatusCommand',
        function updateSwapSectionStatusCommand(deferred, sectionIdstoUpdate: any, status: string[] | string) {
          try {
            let section;
            _4.forEach(sectionIdstoUpdate, (item) => {
              section = ngSectionsDatasource.get(item);
              if (section) {
                section.status = typeof status === 'string' ? status : _4.get(status, `${section.id}`, '');
                ngSectionsDatasource.put(section);
              }
            });
            deferred.resolve(ngSectionsDatasource.read());
          } catch (e) {
            deferred.reject(e);
          }
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/swap/commands/update_swap_section_status_command.ts